import PropTypes from 'prop-types';
import React from 'react';

import classNames from 'classnames';

const MAX_PERCENTAGE = 90;
const UPDATE_INTERVAL = 100;
const UPDATE_PRECENTAGE = 10;

const STATUS = {
  INIT: 0,
  LOADING: 1,
  LOADED: 2,
};

/**
 * Page Loading Bar
 */
class PageLoadingBar extends React.PureComponent {
  static defaultProps = {
    status: 0,
  };

  static propTypes = {
    /**
     * Loading status, 0: not loading, 1: loading, 2: loaded
     */
    status: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      status: 0,
      precentage: 0,
    };
  }

  componentWillMount() {
    this.setState({
      status: this.props.status,
    });
    this.updateProcess(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.status === this.props.status) {
      return;
    }
    this.updateProcess(nextProps);
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  /**
   * Update progess bar process
   * @param  {Object} props
   */
  updateProcess = (props) => {
    if (props.status === STATUS.LOADING) {
      this.simulateProgress();
    }
    if (props.status === STATUS.LOADED) {
      this.setState({
        status: props.status,
        precentage: 100,
      });
      // clear after loaded
      setTimeout(() => {
        this.setState({
          status: STATUS.INIT,
          precentage: 0,
        });
      }, UPDATE_INTERVAL * 5);
    }
  };

  /**
   * Clear timer
   */
  clearTimer = () => {
    clearTimeout(this.timer);
    this.timer = null;
    this.setState({
      status: STATUS.INIT,
      precentage: 0,
    });
  };

  /**
   * Simulate progress bar length change
   */
  simulateProgress = () => {
    // Wait until parent pass a new status props
    if (this.state.precentage >= MAX_PERCENTAGE) {
      clearTimeout(this.timer);
      this.timer = null;
    } else {
      this.timer = setTimeout(() => {
        this.setState({
          status: STATUS.LOADING,
          precentage: this.state.precentage + UPDATE_PRECENTAGE,
        });
        this.simulateProgress();
      }, UPDATE_INTERVAL);
    }
  };

  render() {
    const width = this.state.precentage + '%';
    return (
      <div
        className={classNames('page-loading-bar h_pos-f h_t-0 h_mstart-0 h_end-0', {
          'page-loading-bar--init': this.state.status === STATUS.INIT,
          'page-loading-bar--loading': this.state.status === STATUS.LOADING,
          'page-loading-bar--loaded': this.state.status === STATUS.LOADED,
        })}
        style={{ width }}
        data-testid="page-loading-bar"
      />
    );
  }
}

export default PageLoadingBar;
